import { render } from "./main-page.vue?vue&type=template&id=3dbf36f8&scoped=true"
const script = {}

import "./main-page.vue?vue&type=style&index=0&id=3dbf36f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3dbf36f8"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3dbf36f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dbf36f8', script)) {
    api.reload('3dbf36f8', script)
  }
  
  module.hot.accept("./main-page.vue?vue&type=template&id=3dbf36f8&scoped=true", () => {
    api.rerender('3dbf36f8', render)
  })

}

script.__file = "html/vue/main-page.vue"

export default script